import axios from 'axios';

export default {
  getCountries(succ) {
    axios.get('/countries').then((response) => {
      succ(response.data);
    });
  },
  currencies() {
    return ['USD', 'EUR', 'GBP', 'PLN'];
  },
  rewardDeliveryOptions() {
    return ['europe', 'domestic', 'global'];
  },
};



// WEBPACK FOOTER //
// ./src/api/v1/shared/dictionaries.js